export default __webpack_public_path__ + "static/media/close_Image.2aaabe24.webp";